export default __webpack_public_path__ + "static/media/figo-logo.08d97850.png";